import React from 'react';
import styles from './index.module.scss';
import Card from '@components-clean/core/card';
import SubjectReviewActivityLogGrid from '@pages-clean/subject-monitoring/components/monitoring-toolkit/_shared/subject-review-activity-log-grid';

type Props = {
    studyRef: string;
    reviewId: number;
};

const ActivitySection = ({ studyRef, reviewId }: Props) => {
    return (
        <Card
            data-testid="active-review-activity-grid"
            className={styles.gridCell}
            bodyClassName={styles.gridCellInner}
            padding="none"
        >
            <SubjectReviewActivityLogGrid studyRef={studyRef} reviewId={reviewId} />
        </Card>
    );
};

export default ActivitySection;
